import { Component, ElementRef, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileUploadComponent,
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FileUploadComponent implements ControlValueAccessor {
    private propagateChange: Function = () => {};

    fileName: string | undefined;

    @HostListener('change', ['$event'])
    emitFiles(event: Event) {
        const newFile = (event.target as HTMLInputElement).files?.item(0) ?? null;

        if (newFile) {
            this.fileName = newFile.name;
        }

        this.propagateChange(newFile);
    }

    constructor(private host: ElementRef<HTMLInputElement>) {
    }

    writeValue() {
        // Clear file input
        this.host.nativeElement.value = '';
    }

    registerOnChange(fn: Function) {
        this.propagateChange = fn;
    }

    registerOnTouched(_fn: Function) {
        // Do nothing
    }
}
